import * as React from "react"

export const DownArrowIcon = (props: any) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 17.02 12.74"
            width="1em"
            height="1em"
            {...props}
        >
            <path
                d="M8.52 6.88c.14-.14.27-.25.39-.38 1.26-1.26 2.52-2.53 3.78-3.79.69-.68 1.62-.73 2.23-.12.64.63.6 1.56-.1 2.27-1.7 1.71-3.4 3.42-5.11 5.12-.78.78-1.62.78-2.4 0-1.7-1.7-3.41-3.41-5.11-5.12-.7-.71-.74-1.63-.09-2.26.62-.61 1.55-.56 2.23.12 1.27 1.27 2.54 2.55 3.82 3.82.11.11.22.21.36.34z"
                fill="#999"
            />
        </svg>
    )
}